import ViewBody from './ViewBody';

export default ViewBody;
